import BaseService from '../../../../../services/BaseService';
import * as Role from '../../../../../constants/role';
import { isUsuarioSupervisor } from '../../../../../helpers/inspecaoReportPermission';

export const podeForcarEnvioIntegracao = ({ userRole, authData }) =>
  userRole === Role.DIGITADOR || isUsuarioSupervisor(authData);

const asIdList = (value) => (Array.isArray(value) ? value.map(String) : []);

/** POST /integrate-entities/nsmp/{nsmpId} sem body. Resposta: { success, failed }. */
export const forcarEnvioIntegracaoNsmp = async (nsmpId) => {
  const response = await BaseService.execute({
    url: `integrate-entities/nsmp/${nsmpId}`,
    method: 'POST',
    data: null,
    options: { headers: {} },
  });
  const data = response?.data || {};
  const success = asIdList(data.success);
  const failed = asIdList(data.failed);
  const id = String(nsmpId);
  const ok = !failed.includes(id)
    && (success.includes(id) || (success.length > 0 && failed.length === 0));
  return { ok, success, failed };
};

export const marcarNsmpIntegrada = (row) => ({
  ...row,
  integrationStatus: 'SYNCED',
  resumoIntegracao: {
    ...(row.resumoIntegracao || {}),
    status: 'SYNCED',
    erro: null,
  },
});

export default forcarEnvioIntegracaoNsmp;
